const ERROR_CODES = {
    invalid_grant: 'Неверные логин или пароль.',
    unsupported_grant_type: 'Неверный grant_type приложения. Обратитесь к администратору.',
    invalid_client: 'Неверный client_id или client_key приложения. Обратитесь к администратору.',
    auth: 'Пожалуйста, авторизуйтесь!'
}

export function error(code) {
    return ERROR_CODES[code] ? ERROR_CODES[code] : 'Неизвестная ошибка'
}